import IconsExperiment from './IconsExperiment';
import loadable from '@loadable/component';

const ReferencesIconV3 = loadable(() => import('./ReferencesIconV3'));

const ReferencesIconExperiment = (props) => {
  return <IconsExperiment iconV3={<ReferencesIconV3 {...props} />} />;
};

ReferencesIconExperiment.displayName = 'ReferencesIconExperiment';

export default ReferencesIconExperiment;
